"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductCategory_1 = require("../model/ProductCategory");

var ProductCategoryConverter_1 = require("./ProductCategoryConverter");
/**
 * Implementation of ProductCategoryConverter.
 *
 * @author JMe
 */


var ProductCategoryConverterImpl =
/*#__PURE__*/
function (_ProductCategoryConve) {
  _inherits(ProductCategoryConverterImpl, _ProductCategoryConve);

  function ProductCategoryConverterImpl() {
    _classCallCheck(this, ProductCategoryConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryConverterImpl).apply(this, arguments));
  }

  _createClass(ProductCategoryConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductCategory_1.ProductCategory(ProductCategory_1.ProductCategory.schema.id.valueOf(conversions.documentToClassId(source)), ProductCategory_1.ProductCategory.schema.externalId.valueOfField(source), ProductCategory_1.ProductCategory.schema.numericId.valueOfField(source), ProductCategory_1.ProductCategory.schema.name.valueOfField(source), ProductCategory_1.ProductCategory.schema.parentId.valueOf(conversions.toClassReferenceId(source.parentId)), ProductCategory_1.ProductCategory.schema.childrenIds.valueOf(conversions.asClassReferenceIdsList(source, 'childrenIds')), ProductCategory_1.ProductCategory.schema.level.valueOfField(source), source.classification, ProductCategory_1.ProductCategory.schema.processed.valueOfField(source), ProductCategory_1.ProductCategory.schema.deleted.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        numericId: source.numericId,
        name: source.name,
        parentId: conversions.toDocumentReferenceId(source.parentId),
        childrenIds: conversions.asObjectArray(source, 'childrenIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        level: source.level,
        classification: source.classification,
        processed: source.processed,
        deleted: source.deleted
      });
      return result;
    }
  }]);

  return ProductCategoryConverterImpl;
}(ProductCategoryConverter_1.ProductCategoryConverter);

exports.ProductCategoryConverterImpl = ProductCategoryConverterImpl;